export const MAIN_PLATFORM_BG_CLASS = `sm:bg-loginDay 2xl:bg-loginDayXl dark:sm:bg-loginNight dark:2xl:bg-loginNightXl`;
export const STORK_BG_CLASS = `sm:bg-storkLoginDay xl:bg-storkLoginDayXl 2xl:bg-storkLoginDay2Xl dark:sm:bg-storkLoginNight dark:xl:bg-storkLoginNightXl dark:2xl:bg-storkLoginNight2Xl`;
export const MINDY_BG_CLASS = `bg-mindy`;
export const FLEETCARE_BG_CLASS = `bg-fleetcare`;
export const OMS_BG_CLASS = `bg-oms`;
